import { readableColor } from 'polished';

import { VariantLogoProps } from '.';

export const factor = 100 / 424;

export const Component = ({
	width = 'auto',
	height = 'auto',
	fill,
	...props
}: VariantLogoProps) => (
	<svg
		width={424}
		height={100}
		viewBox="0 0 424 100"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		style={{
			width,
			height,
		}}
		{...props}
	>
		<g clipPath="url(#clip0_1564_10)">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18.4228 5.78534C8.24817 5.78534 0 14.0335 0 24.2081V75.7919C0 85.9664 8.24817 94.2146 18.4228 94.2146H84.7447C94.9193 94.2146 103.168 85.9664 103.168 75.7919V24.2081C103.168 14.0335 94.9193 5.78534 84.7447 5.78534H18.4228ZM23.0763 36.7496C21.6374 38.1884 21.6374 40.5215 23.0763 41.9603L34.8006 53.6845L23.0763 65.4088C21.6374 66.8476 21.6374 69.1807 23.0763 70.6195C24.5152 72.0583 26.8482 72.0583 28.2871 70.6195L42.6167 56.2899C44.0555 54.8511 44.0555 52.518 42.6167 51.0792L28.2871 36.7496C26.8481 35.3108 24.5152 35.3108 23.0763 36.7496ZM44.2146 68.4228C44.2146 66.3878 45.8642 64.7382 47.8992 64.7382H70.0065C72.0415 64.7382 73.6911 66.3878 73.6911 68.4228C73.6911 70.4577 72.0415 72.1073 70.0065 72.1073H47.8992C45.8642 72.1073 44.2146 70.4577 44.2146 68.4228Z"
				fill={fill}
			/>
			<path
				d="M159.975 33.1042C151.279 33.1042 144.25 40.0916 144.25 48.5682C144.25 57.2738 151.279 64.0321 159.975 64.0321C169.386 64.0321 176.415 57.2738 176.415 48.5682C176.415 40.0916 169.267 33.1042 159.975 33.1042ZM159.856 100C146.156 100 136.626 94.9599 130.312 86.2543L142.225 78.4651C145.918 83.3906 151.755 86.5979 159.618 86.5979C169.863 86.5979 176.177 82.4742 176.177 74.1123V72.5086C171.769 76.0596 165.693 77.8923 158.545 77.8923C142.225 77.8923 128.167 65.1776 128.167 48.4536C128.167 31.8442 142.225 18.7858 158.545 18.7858C166.646 18.7858 172.603 21.3058 176.177 24.055V19.7022H192.617V72.7377C192.617 87.858 180.942 100 159.856 100ZM215.728 14.6621H199.169V0H215.728V14.6621ZM215.728 78.4651H199.169V19.7022H215.728V78.4651ZM246.82 19.7022H261.831V33.9061H246.82V57.5029C246.82 62.7721 249.322 64.8339 254.921 64.8339H261.831V78.4651H253.73C237.528 78.4651 230.261 71.4777 230.261 58.3047V33.9061H221.446V19.7022H230.261V4.5819H246.82V19.7022ZM328.067 65.8648C322.11 74.4559 312.699 79.8396 299.118 79.8396C279.581 79.8396 266.953 66.6667 266.953 49.2554C266.953 32.3024 280.058 18.5567 299.237 18.5567C318.536 18.5567 330.211 31.386 330.211 48.4536C330.211 50.7446 329.973 53.7228 329.973 54.0664H283.274C285.061 61.512 290.898 66.323 299.476 66.323C306.862 66.323 312.222 63.2302 315.677 58.5338L328.067 65.8648ZM299.118 31.6151C291.375 31.6151 286.014 35.6243 283.87 42.268H313.533C311.746 35.1661 305.789 31.6151 299.118 31.6151ZM367.141 33.5624C358.087 33.5624 351.059 40.6644 351.059 49.37C351.059 58.1901 358.087 65.1776 367.141 65.1776C376.672 65.1776 383.819 58.1901 383.819 49.37C383.819 40.6644 376.433 33.5624 367.141 33.5624ZM383.581 78.4651V74.1123C379.292 77.3196 372.621 79.2669 365.712 79.2669C349.033 79.2669 334.857 66.323 334.857 49.37C334.857 32.417 349.033 19.1294 365.712 19.1294C372.621 19.1294 379.292 21.1913 383.581 24.3986V19.7022H400.14V78.4651H383.581ZM423.37 14.6621H406.811V0H423.37V14.6621ZM423.37 78.4651H406.811V19.7022H423.37V78.4651Z"
				fill={fill}
			/>
		</g>
		<defs>
			<clipPath id="clip0_1564_10">
				<rect width="423.37" height={100} fill={readableColor(fill)} />
			</clipPath>
		</defs>
	</svg>
);
